import "./PendingLabelingRuleChanges.scss";
import * as R from "ramda";
import { MdClose } from "react-icons/md";
import { SegmentationMappingLabelRule } from "@blisspointmedia/bpm-types/dist/SegmentationMapping";
import PendingRuleChangeEdits from "./PendingRuleChangeEdits";
import { CustomSegmentsData } from "./SegmentationMapping";
import React from "react";

interface PendingLabelingRuleChangesProps {
  originalRules: any[];
  rulesList: SegmentationMappingLabelRule[];
  setRulesList: (rules: SegmentationMappingLabelRule[]) => void;
  editedRules: any[];
  newRules: any[];
  deletedRules: any[];
  setShowPendingChanges: React.Dispatch<React.SetStateAction<boolean>>;
  customSegments: CustomSegmentsData[] | undefined;
}

const PendingLabelingRuleChanges: React.FC<PendingLabelingRuleChangesProps> = ({
  originalRules,
  rulesList,
  setRulesList,
  editedRules,
  newRules,
  deletedRules,
  setShowPendingChanges,
  customSegments = [],
}) => {
  const handleUndoEdit = (row: SegmentationMappingLabelRule) => {
    const originalRule = originalRules.find(r => r.id === row.id);
    const restoredList = rulesList.map(r => {
      return r.id === row.id ? { ...originalRule, rulePriority: row.rulePriority } : r;
    });
    setRulesList(restoredList);
  };

  return (
    <div className="pendingLabelingRuleContainer">
      <div className="pendingLabelingRuleHeader">
        Pending Changes
        <div className="closeButton" onClick={() => setShowPendingChanges(false)}>
          <MdClose />
        </div>
      </div>
      <div className="pendingLabelingRuleBody">
        {!R.isEmpty(editedRules) && (
          <div className="editedRulesSection">
            <span className="changeTitle">Edited Rules</span>
            {editedRules.map(rule => {
              return (
                <PendingRuleChangeEdits
                  key={rule.id}
                  row={rule}
                  originalRules={originalRules}
                  customSegments={customSegments}
                  onUndo={handleUndoEdit}
                />
              );
            })}
          </div>
        )}
        {!R.isEmpty(newRules) && (
          <div className="newRulesSection">
            <span className="changeTitle">Newly Added Rules</span>
            {newRules.map(rule => {
              return (
                <PendingRuleChangeEdits
                  key={rule.createdAt}
                  row={rule}
                  originalRules={originalRules}
                  customSegments={customSegments}
                  isNew
                />
              );
            })}
          </div>
        )}
        {!R.isEmpty(deletedRules) && (
          <div className="deletedRulesSection">
            <span className="changeTitle">Deleted Rules</span>
            {deletedRules.map(rule => {
              return (
                <PendingRuleChangeEdits
                  key={rule.id}
                  row={rule}
                  originalRules={originalRules}
                  customSegments={customSegments}
                  onUndo={row => {
                    setRulesList([...rulesList, rule]);
                  }}
                  isDeleted
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingLabelingRuleChanges;
